<style lang="scss">
  @import '../resources/scss/growing_family.scss';
</style>

<script lang="ts">
  import { onDestroy } from 'svelte'

  import type GrowingFamilySection from '../api/rest/directus-cms/app/models/GrowingFamilySection'

  import { commonWebsiteData } from '../stores/stores'

  let growingFamilyData: GrowingFamilySection

  const unsubscribeWebsiteData = commonWebsiteData.subscribe(data => {
    if (data?.growing_family_section) growingFamilyData = data?.growing_family_section
  })

  onDestroy(() => {
    unsubscribeWebsiteData()
  })
</script>

{#if growingFamilyData}
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-lg-6 growing-image" />
      <div class="col-12 col-lg-6 text-section text-white">
        <div class="container-xxl">
          <h2 class="pb-4">{growingFamilyData.title}</h2>
          <div class="description text-white body">
            {@html growingFamilyData.text}
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
